import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { Button } from '@3plearning/react-components';
import { MessageWrapper, MessageText, OpenButtonWrapper } from './styled';
import { getInstructionHubAssignmentsConfig } from '../../helpers/instruction-hub/instruction-hub-assignments';

export const INSTRUCTION_HUB_MESSAGE_CONTEXTS = {
  CELL: 'cell',
  ACTIVITY: 'activity',
  STUDENT: 'student',
  TOPIC: 'topic'
};

function getMessage(i18n, context) {
  switch (context) {
    case INSTRUCTION_HUB_MESSAGE_CONTEXTS.ACTIVITY:
      return i18n._(
        t(
          'instructionHub.activityMessage'
        )`This activity is managed in Instruction Hub, so it can’t be changed here.`
      );
    case INSTRUCTION_HUB_MESSAGE_CONTEXTS.STUDENT:
      return i18n._(
        t(
          'instructionHub.studentMessage'
        )`All available activities for this student are managed in Instruction Hub, so this selection can’t be changed here.`
      );
    case INSTRUCTION_HUB_MESSAGE_CONTEXTS.TOPIC:
      return i18n._(
        t(
          'instructionHub.topicMessage'
        )`All activities in this topic are managed in Instruction Hub, so this topic can’t be changed here.`
      );
    case INSTRUCTION_HUB_MESSAGE_CONTEXTS.CELL:
    default:
      return i18n._(
        t(
          'instructionHub.cellMessage'
        )`This activity is managed in Instruction Hub for this student, so it can’t be changed here.`
      );
  }
}

const InstructionHubMessage = ({ i18n, context, onOpen }) => {
  const { deepLink } = getInstructionHubAssignmentsConfig();

  const openInstructionHub = () => {
    window.open(deepLink, '_blank');
    onOpen();
  };

  return (
    <MessageWrapper
      data-testid="instruction-hub-message"
      onClick={(event) => event.stopPropagation()}
    >
      <MessageText>{getMessage(i18n, context)}</MessageText>
      {deepLink && (
        <OpenButtonWrapper data-testid="open-instruction-hub-button">
          <Button
            primary
            text={i18n._(
              t('instructionHub.openButton')`Open in Instruction Hub`
            )}
            type={Button.LOZENGE}
            onClick={openInstructionHub}
          />
        </OpenButtonWrapper>
      )}
    </MessageWrapper>
  );
};

InstructionHubMessage.propTypes = {
  i18n: PropTypes.object.isRequired,
  context: PropTypes.oneOf(Object.values(INSTRUCTION_HUB_MESSAGE_CONTEXTS))
    .isRequired,
  onOpen: PropTypes.func.isRequired
};

export default InstructionHubMessage;



// WEBPACK FOOTER //
// ./components/instruction-hub-message/index.js